import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AllEnums } from '~/data/enums';
import {
  getCountryByLegalEntity,
  useAllLegalEntities,
} from '~/data/legalEntity';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmploymentDetail/components/FormComponent/useStyles';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helper';

type Props = {
  control: Control<Form>;
  errors: FieldErrors<Form>;
  getValues: UseFormGetValues<Form>;
  allEnums: AllEnums;
  index: number;
  setValue: UseFormSetValue<Form>;
  disabled?: boolean;
};

export const JobGradeComponent = ({
  control,
  allEnums,
  errors,
  index,
  getValues,
  setValue,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  useWatch({
    control,
    name: `schedule.${index}.empPosition.fEmpLegalEntity`,
  });

  useWatch({
    control,
    name: `schedule.${index}.empPosition.fInternalPositionUnit`,
  });

  const fEmpLegalEntityValue = getValues(
    `schedule.${index}.empPosition.fEmpLegalEntity`,
  );

  const fEmpOrgUnitValue = getValues(
    `schedule.${index}.empPosition.fInternalPositionUnit`,
  );

  const { legalEntities } = useAllLegalEntities();

  const filteredOptions = filterActiveEnumsByCountryAndOrgUnits(
    allEnums['JOB_GRADE'],
    getCountryByLegalEntity(+fEmpLegalEntityValue, legalEntities),
    fEmpOrgUnitValue,
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employmentDetails.fEmplDetailJobGrade`}
      render={({ field: { onChange, value } }) => (
        <LegacyAutocompleteField
          options={filteredOptions}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          onChange={(_, value) => onChange(value?.code || '')}
          value={filteredOptions.find((o) => o?.code === value) || null}
          sx={sxStyles.selectStyle}
          fieldError={
            errors.schedule?.[index]?.employmentDetails?.fEmplDetailJobGrade
          }
          label={t('fJobGrade')}
          disabled={disabled}
        />
      )}
    />
  );
};
